import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { EcoChallengeFileOrdersModel } from "@/common/models/eco-challenge-file-orders.model";

export class EcoChallengeFileApiService extends ApiService {
  static endpoint = 'eco-challenge-file';

  /**
   * @param {Number|null} fileId
   * @param {String|null} subresource
   * @return {String}
   * @protected
   */
  static buildFileUrl(fileId = null, subresource = null) {
    return subresource ? this.buildUrl(`${fileId}/${subresource}`) : this.buildUrl(fileId);
  }

  /**
   * @param {string | number} id
   * @param {builderCallback} builderCallback
   * @param {object} config
   * @returns {Promise}
   * @public
   */
  static async getOrders(id, builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildFileUrl(id, 'orders'), {
      ...config,
      dataModel: EcoChallengeFileOrdersModel,
      useVApi: true,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {string | number} id
   * @param {Object} data
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<EcoChallengeFileOrdersModel>>}
   * @public
   */
  static async createOrdersPairing(id, data = {}, builderCallback = null, config = {}) {
    return HttpApiClient.post(this.buildFileUrl(id, 'orders-pairing'), data, {
      ...config,
      dataModel: EcoChallengeFileOrdersModel,
      useVApi: true,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }
}
